import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Rotate"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M13.432 20.1149L13.6945 21.6149C14.8141 21.4197 15.8906 21.0287 16.8745 20.4599L16.1245 19.1624C15.29 19.6358 14.3785 19.9582 13.432 20.1149ZM18.3146 17.3024L19.4996 18.2624C20.226 17.3902 20.7946 16.3978 21.1796 15.3299L19.7771 14.8199C19.439 15.7268 18.9439 16.5671 18.3146 17.3024ZM7.12456 20.4375C8.10849 21.0062 9.18495 21.3972 10.3046 21.5925L10.5671 20.0925C9.6191 19.9287 8.70757 19.5986 7.87456 19.1175L7.12456 20.4375ZM4.25211 14.8199L2.84961 15.3299C3.22551 16.3957 3.78382 17.388 4.49961 18.2624L4.73961 18.0674L5.65461 17.3174C5.03592 16.5799 4.55111 15.7397 4.22211 14.8349L4.25211 14.8199ZM21.7495 11.9999C21.7475 10.8632 21.5444 9.73587 21.1495 8.66994L19.747 9.17994C20.075 10.0842 20.245 11.0381 20.2495 11.9999H21.7495ZM19.4996 5.73744C17.6472 3.50745 14.8985 2.21741 11.9996 2.21741C9.10057 2.21741 6.35193 3.50745 4.49956 5.73744V2.99994H2.99956V8.99994H8.99956V7.49994H5.10706C6.53438 5.31944 8.90806 3.94155 11.5094 3.78349C14.1107 3.62543 16.6337 4.70579 18.3146 6.69744L19.4996 5.73744Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Rotate.vue"]]);
